module.exports = __webpack_public_path__ + "img/development_news_title1.e11a5940.png";